import React, {useEffect, useState} from "react";
import PanelAddBalanceRequest from "../../../UI/AddBalanceRequests/add";
import {Helper} from "../../../tools/Helper";
import {api_Routes} from "../../../tools/api_Routes";
import AddOrderForm from "../../../UI/Orders/add";
import PanelBody from "../../../UI/Panel/PanelBody";
import PanelHead from "../../../UI/Panel/PanelHead";
import PanelAddOrderRequest from "../../../UI/OrderRequests/add";

const AddOrderRequests = () => {
    const [isRequestsLoading, setIsRequestsLoading] = useState(true);
    const [isUsersLoading, setUsersLoading] = useState(true);
    const [requests, setRequests] = useState([]);
    const [users, setUsers] = useState([]);

    const getRequests = async () => {
        setIsRequestsLoading(true);
        const { response } = await Helper.Get({
            url: api_Routes.Orders.ViewAllRequest, // Update this API route as needed
            hasToken: true,
        });
        if (response) {
            setRequests(response?.data || []); // Extract the data array from response
        }
        setIsRequestsLoading(false);
    };

    const getUsers = async () => {
        setUsersLoading(true);
        const { response, message } = await Helper.Get({
            url: `${api_Routes.Users.ViewAllByReseller}`,
            hasToken: true,
        });
        if (response) {
            setUsers(response?.data || []);
        }
        setUsersLoading(false);
    };

    useEffect(() => {
        getRequests();
        getUsers();
    }, []);

    return (
        <div>
            <PanelHead title="Add Order Request" />
            <PanelBody
                content={
                    <PanelAddOrderRequest
                        requests={requests}
                        isRequestsLoading={isRequestsLoading}
                        users={users}
                        isUsersLoading={isUsersLoading}
                    />
                }
            />
        </div>
    );
};

export default AddOrderRequests;